module.exports = __webpack_public_path__ + "static/media/9DESA1.82b6e19e.jpg";